import { Component, Input } from '@angular/core';
import { EventsProvider } from '../../providers/events/events';
import { AppState } from '../../config/state';

/**
 * Generated class for the CoEventTypesPillComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-event-types-pill',
  templateUrl: 'co-event-types-pill.html',
  inputs: ['typeName']
})
export class CoEventTypesPillComponent {
  @Input('typeName') typeName: string;
  eventTypeList: any;
  text: string;
  eventColor: string;

  constructor(public eventsProvider: EventsProvider, private state: AppState) {

  }

  ngOnInit() {
    if(!this.state.eventColors || !this.state.eventColors.types) {
      this.eventsProvider.getEventTypes().then( types => {
        this.eventTypeList = types;
        this.getEventColor();
      });
    }
    else {
      this.eventTypeList = this.state.eventColors.types;
      this.getEventColor();
    }
  }

  async getEventColor(){
    this.eventTypeList = this.state.eventColors.types;
    try {
      let eventTypeObject = this.eventTypeList.find(object => object.name === this.typeName);
      this.eventColor = eventTypeObject.color;
    } catch (ex) {
      this.eventColor = "green";
    };
  }

}



// WEBPACK FOOTER //
// ./src/components/co-event-types-pill/co-event-types-pill.ts